import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getBreadcrumbOption } from '../Sidebar/options';
import IntlMessages from '../../components/utility/intlMessages';
import appActions from '../../redux/app/actions';
import BreadcrumbWrapper, {
  NavRoutes,
  NavLinks,
  PageInfo,
  FakeBoxWithTab,
  FakeBox,
  // Icons,
} from './style';

const bredContainerId = 'bredContainer';
const EmptyBreadcrumb = () => <div id={bredContainerId} />;

class PageBreadcrumb extends Component {
  state = {
    selectedNav: null,
  };
  onHomeCLick = () => {
    const { changeOpenKeys, changeCurrent } = this.props;
    changeOpenKeys({});
    changeCurrent({});
  };
  componentDidMount() {
    this.onBredHeightChange();
  }
  componentDidUpdate() {
    this.onBredHeightChange();
  }
  onBredHeightChange = () => {
    let height = 0;
    try {
      height = document.getElementById(bredContainerId).firstElementChild.clientHeight;
    } catch (e) {}
    const { bredHeight, changeBredHeight } = this.props;
    if (height !== bredHeight) {
      changeBredHeight(height);
    }
  };
  render() {
    const { customizedTheme, style, breadcrumbs } = this.props;

    return (
      <div style={style} id={bredContainerId}>
        <BreadcrumbWrapper
          style={{ background: customizedTheme.backgroundColor }}
        >
          <PageInfo>
            <h3 className="pageTitle" style={{ color: customizedTheme.textColor }}>
              {breadcrumbs.pageTitle}
            </h3>
          </PageInfo>

          <NavRoutes>
            {
              breadcrumbs.crumbs.map((crumb, idx) => {
                if (idx+1 !== breadcrumbs.crumbs.length) {
                  return (
                    <Link key={idx} to={`${crumb.link}`} style={{ color: customizedTheme.textColor }}>
                      {crumb.label}
                    </Link>
                  );
                } else {
                  return (
                    <Link key={idx} to={`${crumb.link}`} onClick={e => e.preventDefault()} style={{ color: customizedTheme.textColor }}>
                      {crumb.label}
                    </Link>
                  );
                }
              })
            }
          </NavRoutes>

        </BreadcrumbWrapper>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.App,
    customizedTheme: state.ThemeSwitcher.breadCrumbTheme,
  };
};
export default connect(mapStateToProps, appActions)(PageBreadcrumb);



// WEBPACK FOOTER //
// ./src/containers/PageBreadcrumb/index.js